import type { RuntimeState } from '@/workflow-builder/_contract/runtime';


function getLastBuilderExecutionRequestId(runtimeState: RuntimeState): number {
    return runtimeState.executionState.executionStateKind === 'idle'
        ? runtimeState.executionState.lastRequestId
        : runtimeState.executionState.requestId;
}

export function beginExecution(runtimeState: RuntimeState): {
    runtimeState: RuntimeState;
    requestId: number;
} | undefined {
    if (runtimeState.executionState.executionStateKind === 'running') return undefined;

    const requestId = getLastBuilderExecutionRequestId(runtimeState) + 1;
    return {
        requestId,
        runtimeState: {
            ...runtimeState,
            executionState: {
                executionStateKind: 'running',
                requestId,
            },
            error: null,
        },
    };
}

export function isCurrentExecution(
    runtimeState: unknown,
    requestId: number,
): runtimeState is RuntimeState {
    if (typeof runtimeState !== 'object' || runtimeState === null) return false;
    const candidate = runtimeState as Partial<RuntimeState>;

    return candidate.adapterMode === 'builder'
        && candidate.executionState?.executionStateKind === 'running'
        && candidate.executionState.requestId === requestId;
}

export function failExecution(
    runtimeState: RuntimeState,
    requestId: number,
    error: RuntimeState['error'],
): RuntimeState {
    if (!isCurrentExecution(runtimeState, requestId)) return runtimeState;

    return {
        ...runtimeState,
        executionState: {
            executionStateKind: 'failed',
            requestId,
            message: error?.message ?? 'Workflow execution failed.',
        },
        error,
    };
}

export function resetExecution(runtimeState: RuntimeState): RuntimeState {
    if (runtimeState.executionState.executionStateKind === 'idle') return runtimeState;

    return {
        ...runtimeState,
        executionState: {
            executionStateKind: 'idle',
            lastRequestId: getLastBuilderExecutionRequestId(runtimeState),
        },
    };
}